/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import _ from 'lodash';
import $ from 'jquery';
import can from 'can';
import youbora from 'vendors/youbora/sp.min';
import Component from 'can/component/component';
import DomEventsManager from 'scripts/dom-events-manager';
import appConfig from 'scripts/app-config';
// import ConvivaService from 'scripts/services/conviva-service';
import template from './live-brightcove-video.stache';
import Modernizr from 'modernizr';
import deviceUtil from 'scripts/utils/device';

const brightcoveOptions = _.get(window.globalSettings, 'brightcove');
const youboraOptions = _.get(window.globalSettings, 'youbora', {});

Component.extend({
    tag: 'live-brightcove-video',
    template,
    leakScope: false,
    viewModel: {
        define: {
            scroll: {
                type: 'boolean',
                value: false
            },
            isActive: {
                type: 'boolean',
                value: false
            },
            playerId: {
                type: 'string',
                value: _.get(brightcoveOptions, 'live.playerId')
            },
            accountId: {
                type: 'string',
                value: brightcoveOptions.accountId
            },
            videoId: {
                type: 'string',
                value: null
            },
            autoplay: {
                type: 'boolean',
                value: _.has(brightcoveOptions.live, 'autoPlay') ? brightcoveOptions.live.autoPlay : true
            },
            muted: {
                type: 'boolean',
                value: false,
            },
            isAdFinished: {
                type: 'boolean'
            },
            showThumbnail: {
                type: 'boolean',
                value: false
            }
        },
        onVideoInserted () {
            const self = this;
            const videoId = this.attr('videoId');
            const setYouboraAnalytics = this.setYouboraAnalytics.bind(this);
            const playerUrl = _.get(appConfig, 'urls.api.brightcove.playerUrl');
            const accountId = this.attr('accountId');
            const playerId = this.attr('playerId');
            const isAdFinished = this.attr('isAdFinished');

            if (!playerUrl || !accountId || !playerId) {
                return console.error('Player is not configured correctly');
            }

            window._define = window.define;
            window.define = undefined;

            let isAutoplayEnabled = false;

            Modernizr.on('videoautoplay', function(result) {
                isAutoplayEnabled = !!result;
            });

            can.$.getScript(can.sub(playerUrl, {accountId, playerId}))
                .done(() => {
                    window.define = window._define;
                    window.videojs('live-player').ready(function () {
                        if (!deviceUtil.isIos && (deviceUtil.isMobile || window.innerWidth <= 768)) {
                            this.autoplay(false);
                        }
                        self.attr('player', this);
                        this.catalog.getVideo(videoId, (error, video) => {
                            if (error) {
                                return console.error(`Video ${videoId} can not be loaded`);
                            }
                            self.dispatch({type: 'metadata', data: video });

                            this.catalog.load(video);

                            setYouboraAnalytics(this);
                        });

                        const videoElement = this.el_.querySelector('video');

                        deviceUtil.isMobile && $(document).on('webkitfullscreenchange mozfullscreenchange msfullscreenchange fullscreenchange', (e) => {
                            if (self.attr('player') && !self.attr('player').isFullscreen()) {
                                self.attr('player').pause();
                            }
                        });

                        this.on('play', () => {
                            self.attr('showThumbnail', false);
                        });

                        Modernizr.on('videoautoplay', (hasAutoplay) => {
                            if (!hasAutoplay) {
                                self.attr('showThumbnail', true);
                            }

                            if (!isAdFinished) {
                                this.one('ads-ad-started', () => {
                                    videoElement.muted = true;
                                    self.attr('showThumbnail', false);
                                });
                                this.one('ads-ad-ended', () => {
                                    self.attr('isAdFinished', true);
                                    videoElement.muted = self.attr('muted');

                                    if (isAutoplayEnabled) {
                                        self.attr('showThumbnail', false);
                                        this.play();
                                    } else {
                                        self.attr('showThumbnail', true);
                                        this.pause();
                                    }
                                });

                                if (!this.ima3) {
                                    return;
                                }

                                this.ima3.ready(() => {
                                    this.muted(self.attr('muted'));
                                    this.play();
                                });
                            } else {
                                this.muted(self.attr('muted'));
                                this.play();
                            }
                        });
                    });
                })
                .fail(function (jqxhr, settings, exception) {
                    console.log('Error getting brightcove player ', exception);
                });
        },
        setYouboraAnalytics (player) {
            player.youboraplugin = new youbora.plugins.Videojs5(player, {
                accountCode: youboraOptions.accountCode,
                media: {
                    isLive: true
                }
            });
        },
        toggleFullScreen () {
            let player = this.attr('player');
            if (player) {
                player.requestFullscreen();
            }
        }
    },
    events: {
        inserted: function () {
            const vm = this.viewModel;
            vm.element = this.element;

            if (!vm.attr('scroll') && vm.attr('accountId') && vm.attr('playerId') && vm.attr('videoId')) {
                DomEventsManager.subscribe(this);
                vm.attr('isActive', true);
                $('html').addClass('scroll-disabled');
            }
        },

        removed: function () {
            $('html').removeClass('scroll-disabled');
            DomEventsManager.unsubscribe(this);
        },

        '.s-image-preview click':  function() {
            this.viewModel.attr('showThumbnail', false);
            const player = this.viewModel.attr('player');
            if (player) {
                player.play();
            }
        },
    }
});
